// @TODO
// consider adding a "refresh" property, triggered by socket which can be
// used to decide if performing a news request when entering a route
// otherwise we can always refresh on socket message, or ask the user
export const initialApiState = (defaultData, additionalState = {}) => ({
  fetching: false,
  fetched: false,
  error: false,
  errorMessage: null,
  errorCode: null,
  data: defaultData,
  ...additionalState,
})

export const requestReducer = (state) => { state.fetching = true }
export const successReducer = (state, action) => ({
  ...state,
  fetching: false,
  fetched: true,
  error: false,
  errorMessage: null,
  data: action.payload,
})
export const failureReducer = (defaultData) => (state, action) => ({
  ...state,
  fetching: false,
  fetched: true,
  error: true,
  errorMessage: action.payload.message,
  errorCode: action.payload.code,
  data: defaultData,
})

export const apiReducers = (defaultData) => ({
  request: requestReducer,
  success: successReducer,
  failure: failureReducer(defaultData),
})

export const apiSlice = (name, defaultData, additionalState = {}) => ({
  name,
  initialState: initialApiState(defaultData, additionalState),
  reducers: apiReducers(defaultData),
})

export const initialApiMapState = (defaultData, additionalState = {}) => ({
  fetching: {},
  fetched: {},
  error: {},
  errorMessage: {},
  errorCode: {},
  data: defaultData,
  ...additionalState,
})

export const requestMapReducer = (state, action) => ({
  ...state,
  fetching: { ...state.fetching, [action.payload]: true },
})
export const successMapReducer = (state, action) => ({
  ...state,
  fetching: { ...state.fetching, [action.payload.id]: false },
  fetched: { ...state.fetched, [action.payload.id]: true },
  error: { ...state.error, [action.payload.id]: false },
  errorMessage: { ...state.errorMessage, [action.payload.id]: null },
  data: { ...state.data, [action.payload.id]: action.payload.data },
})

export const failureMapReducer = (defaultData) => (state, action) => ({
  ...state,
  fetching: { ...state.fetching, [action.payload.id]: false },
  fetched: { ...state.fetched, [action.payload.id]: true },
  error: { ...state.error, [action.payload.id]: true },
  errorMessage: { ...state.errorMessage, [action.payload.id]: action.payload.message },
  errorCode: { ...state.errorMessage, [action.payload.id]: action.payload.code },
  data: defaultData,
})

export const apiMapReducers = (defaultData) => ({
  request: requestMapReducer,
  success: successMapReducer,
  failure: failureMapReducer(defaultData),
})

export const apiMapSlice = (name, defaultData = {}, additionalState = {}) => ({
  name,
  initialState: initialApiMapState(defaultData, additionalState),
  reducers: apiMapReducers(defaultData),
})
